export interface Attachment {
  workspaceId?: string;
  createdAt: string;
  URL: string;
  name: string;
  type: MediaType;
  mime: string;
  width: number;
  height: number;
  thumbnailURL: string;
  id: string;
  size: number;
}

export interface AttachmentPayload {
  workspaceId: string;
  URL: string;
  type: string;
  mime: string;
  name: string;
  width: number;
  height: number;
  thumbnailURL: string;
  size: number;
}

export enum MediaType {
  image = 'image',
  video = 'video',
}
